import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const ABOUT_ME_STORE_NAME = 'aboutMe'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
